import { render, staticRenderFns } from "./WeeksJobs.vue?vue&type=template&id=0286a0a6&scoped=true&"
import script from "./WeeksJobs.vue?vue&type=script&lang=ts&"
export * from "./WeeksJobs.vue?vue&type=script&lang=ts&"
import style0 from "./WeeksJobs.vue?vue&type=style&index=0&id=0286a0a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0286a0a6",
  null
  
)

export default component.exports